import { submitChatMessages } from "./submitChatMessages";
import { appendAdminMessage } from "./appendAdminMessage";
import { answerTrigger } from "../../../../../growtype-quiz/resources/js/components/answerTrigger";
import { nextQuestionTrigger } from "../../../../../growtype-quiz/resources/js/components/nextQuestionTrigger";
import { previousQuestionTrigger } from "../../../../../growtype-quiz/resources/js/components/previousQuestionTrigger";
import { input } from "../../../../../growtype-quiz/resources/js/components/input";
import { unitSystem } from "../../../../../growtype-quiz/resources/js/components/unitSystem";
import { showInitialQuestion } from "../../../../../growtype-quiz/resources/js/actions/question/showInitialQuestion";
import { modal } from "../../../../../growtype-quiz/resources/js/components/modal";
import { updateQuestionsCounter } from "../../../../../growtype-quiz/resources/js/actions/progress/counter/updateQuestionsCounter";
import { updateProgressBar } from "../../../../../growtype-quiz/resources/js/actions/progress/bar/updateProgressBar";
import { updateProgressCounter } from "../../../../../growtype-quiz/resources/js/actions/progress/counter/updateProgressCounter";
import { duration } from "../../../../../growtype-quiz/resources/js/actions/progress/timer/duration";
import { countDownTimer } from "../../../../../growtype-quiz/resources/js/actions/progress/timer/countDownTimer";

/**
 * Initialise a quiz wrapper – exported for use after DOM replacements.
 */
export function setupQuiz(quizWrapper) {
    // Set params if function exists
    if (typeof growtypeQuizSetParams !== 'undefined') {
        growtypeQuizSetParams(quizWrapper);
    }

    // Question related triggers
    nextQuestionTrigger(quizWrapper);
    input(quizWrapper);
    unitSystem(quizWrapper);
    showInitialQuestion(quizWrapper);
    modal(quizWrapper);
    previousQuestionTrigger(quizWrapper);
    updateQuestionsCounter(quizWrapper);
    updateProgressBar(quizWrapper);
    updateProgressCounter(quizWrapper);
    duration(quizWrapper);
    countDownTimer(quizWrapper);

    // Answer trigger
    new answerTrigger().init(
        quizWrapper.find('.growtype-quiz-question-answers .growtype-quiz-question-answer')
    );
}

/**
 * Initialise all quiz wrappers inside a chat form when the DOM is ready.
 */
export function questionQuiz(chatform) {
    $(document).ready(function () {
        chatform.find('.growtype-quiz-wrapper').each(function (index, element) {
            setupQuiz($(element));
        });
    });
}

export function scrollChatQuizQuestionIntoView(currentQuestion) {
    const question = $(currentQuestion || []);
    const chatContent = question.closest('.g-chatform-content');

    if (!question.length || !chatContent.length) {
        return false;
    }

    const questionElement = question.get(0);
    const contentElement = chatContent.get(0);
    if (!questionElement || !contentElement) {
        return false;
    }

    const questionTop = questionElement.getBoundingClientRect().top;
    const contentTop = contentElement.getBoundingClientRect().top;
    const targetScrollTop = Math.max(
        0,
        contentElement.scrollTop + questionTop - contentTop - 10
    );

    chatContent.stop(true, false).animate({ scrollTop: targetScrollTop }, 200);

    return true;
}

document.addEventListener('growtypeQuizShowQuestion', function (event) {
    scrollChatQuizQuestionIntoView(event.detail?.currentQuestion);
});

/** Event: quiz answered successfully */
document.addEventListener('growtypeQuizShowSuccessQuestion', growtypeQuizShowSuccessQuestion);
function growtypeQuizShowSuccessQuestion(params) {
    const chatForm = $(params.detail.currentQuestion).closest('.g-chatform');
    const quizWrapper = $(params.detail.currentQuestion).closest('.growtype-quiz-wrapper');
    const quizId = quizWrapper.attr('id');

    if (chatForm.length > 0) {
        const questionsAmount = $(params.detail.currentQuestion).closest('.growtype-quiz').find('.growtype-quiz-question').length;
        $(params.detail.currentQuestion).closest('.g-chatform-message').hide();

        const messageData = {
            quiz_answers: growtype_quiz_data[quizId]['answers'],
            message_id: $(params.detail.currentQuestion).closest('.g-chatform-message').attr('data-id'),
            frontend_delay_case: 'quiz_submission',
            interaction_type: 'quiz_answer',
            extra_details: {
                quiz_id: quizWrapper.attr('data-quiz-post-id'),
                quiz_type: quizWrapper.attr('data-quiz-type'),
                quiz_slug: quizWrapper.attr('data-quiz-slug'),
            },
        };

        const extractFirstQuizAnswerValue = function (answers) {
            if (!answers || typeof answers !== 'object') {
                return '';
            }
            for (const questionAnswers of Object.values(answers)) {
                if (!Array.isArray(questionAnswers)) continue;
                for (const answer of questionAnswers) {
                    if (answer && typeof answer === 'object' && !Array.isArray(answer)) {
                        if (typeof answer.value === 'string' && answer.value.trim() !== '') return answer.value.trim();
                    } else if (typeof answer === 'string' && answer.trim() !== '') {
                        return answer.trim();
                    }
                }
            }
            return '';
        };

        const quizAnswers = growtype_quiz_data[quizId]?.['answers'] || {};
        messageData.value = extractFirstQuizAnswerValue(quizAnswers);

        if (questionsAmount > 1) {
            messageData.value = 'Calculating results...';
            messageData.skip_question_preview = true;
        }

        if (messageData.value && !messageData.skip_question_preview) {
            appendAdminMessage(chatForm, messageData.value, messageData.skip_question_preview);
        }

        try {
            submitChatMessages([messageData], chatForm);
            growtype_quiz_data[quizId]['answers'] = {};
        } catch (error) {
            console.error('An error occurred: ', error);
        }
    }
}

/** Event: after a chat message finishes rendering – re‑initialise any quiz inside it */
document.addEventListener('growtypeChatMessageReturnFinished', growtypeChatMessageReturnFinished);
function growtypeChatMessageReturnFinished(params) {
    const quizWrapper = params.detail.userMessageTemplate.find('.growtype-quiz-wrapper');
    if (quizWrapper && quizWrapper.length) {
        setupQuiz(quizWrapper);
        document.dispatchEvent(new CustomEvent('growtypeQuizStart', {
            detail: { quizWrapper: quizWrapper.get(0) },
        }));
    }
}
